<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Reclamos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Reclamos y Oportunidades de Mejora

    v-dialog(v-model='dialog', persistent, max-width='700px')
      v-card(style='background-color:white;')
        v-card-title.justify-center
          span.headline Detalle del Reclamo
        v-card-text(style='max-height:70vh;overflow-y:auto;')
          v-container(grid-list-md)
            v-layout(wrap)
              v-flex(xs12, sm6)
                v-text-field(v-model='form.vendedorNombre', label='Vendedor', readonly, outline)
              v-flex(xs12, sm6)
                v-text-field(v-model='form.vendedorCodigo', label='Código Vendedor', readonly, outline)
              v-flex(xs12, sm6)
                v-text-field(v-model='form.clienteNombre', label='Cliente', readonly, outline)
              v-flex(xs12, sm6)
                v-text-field(:value='tipoLabel(form.tipo)', label='Tipo', readonly, outline)
              v-flex(xs12)
                v-text-field(:value='formatDate(form.fechaCreacion)', label='Fecha', readonly, outline)
              v-flex(xs12)
                v-textarea(v-model='form.descripcion', label='Descripción', readonly, outline, rows='4')
              v-flex(xs12, v-if='form.estatus !== "pendiente"')
                v-textarea(v-model='form.respuesta', label='Respuesta del admin', readonly, outline, rows='3')

              v-flex(xs12, v-if='form.archivosUrls && form.archivosUrls.length')
                div.mb-1
                  strong Archivos adjuntos ({{ form.archivosUrls.length }})
                div(style='display:flex;flex-wrap:wrap;gap:10px;margin-top:6px;')
                  div(v-for='(url, idx) in form.archivosUrls', :key='idx', style='position:relative;')
                    template(v-if='esVideo(url)')
                      video(
                        :src='url'
                        controls
                        style='width:160px;height:110px;object-fit:cover;border-radius:8px;border:1px solid #ddd;'
                      )
                    template(v-else)
                      a(:href='url', target='_blank')
                        img(
                          :src='url'
                          style='width:110px;height:110px;object-fit:cover;border-radius:8px;border:1px solid #ddd;cursor:pointer;'
                        )

              v-flex(xs6)
                strong Estatus:&nbsp;
                v-chip(:color='colorEstatus(form.estatus)', dark, small) {{ form.estatus | capitalize }}

              v-flex(xs12, v-if="form.estatus === 'pendiente'")
                v-divider.mb-2
                v-textarea(v-model='respuestaInput', label='Respuesta (opcional)', outline, rows='3')

              v-flex(xs12)
                v-divider.mb-3
                div(style='display:flex;justify-content:center;gap:8px;flex-wrap:wrap;')
                  v-btn(
                    v-if="form.estatus === 'pendiente'"
                    color='green darken-1', dark
                    @click='cambiarEstatus("atendido")'
                    :loading='loading'
                  ) Marcar atendido
                  v-btn(
                    v-if="form.estatus === 'pendiente'"
                    color='red darken-1', dark
                    @click='cambiarEstatus("rechazado")'
                    :loading='loading'
                  ) Rechazar
                  v-btn(@click='close') Cerrar

    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, style='margin-top: 5px;')
        v-card(style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Lista de Reclamos

        v-layout(style='padding:10px 16px 0;', row, wrap)
          v-flex(xs12, sm4)
            v-select(
              v-model='filtroEstatus'
              :items='opcionesEstatus'
              label='Filtrar por estatus'
              clearable, outline, dense
            )
          v-flex(xs12, sm4)
            v-select(
              v-model='filtroTipo'
              :items='opcionesTipo'
              label='Filtrar por tipo'
              clearable, outline, dense
            )

        v-data-table.elevation-1(
          :headers='headers'
          :items='reclamosFiltrados'
          :loading='loading'
          :pagination.sync='pagination'
          style="margin-top: 5px;"
        )
          template(slot='items', slot-scope='props')
            td {{ props.item.vendedorNombre || '—' }}
            td {{ props.item.clienteNombre || '—' }}
            td
              v-chip(:color='colorTipo(props.item.tipo)', dark, small) {{ tipoLabel(props.item.tipo) }}
            td(style='max-width:220px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;') {{ props.item.descripcion }}
            td {{ formatDate(props.item.fechaCreacion) }}
            td
              v-chip(:color='colorEstatus(props.item.estatus)', dark, small) {{ props.item.estatus | capitalize }}
            td
              v-btn.mx-0(icon, @click='verDetalle(props.item)', title='Ver detalle')
                v-icon(color='green') visibility
              v-btn.mx-0(icon, @click='eliminar(props.item._id)', title='Eliminar', :disabled='loading')
                v-icon(color='red') delete_outline
</template>

<script>
import Api from "@/services/methods";
import moment from 'moment';

export default {
  name: "Reclamos",
  data: () => ({
    loading: false,
    dialog: false,
    reclamos: [],
    filtroEstatus: null,
    filtroTipo: null,
    respuestaInput: '',
    opcionesEstatus: ['pendiente', 'atendido', 'rechazado'],
    opcionesTipo: [
      { text: 'Reclamo', value: 'reclamo' },
      { text: 'Oportunidad de Mejora', value: 'mejora' },
      { text: 'Sugerencia', value: 'sugerencia' },
    ],
    form: {
      _id: null,
      vendedorNombre: '',
      vendedorCodigo: '',
      clienteNombre: '',
      tipo: '',
      descripcion: '',
      respuesta: '',
      estatus: 'pendiente',
      fechaCreacion: null,
      archivosUrls: [],
    },
    headers: [
      { text: 'Vendedor', value: 'vendedorNombre' },
      { text: 'Cliente', value: 'clienteNombre' },
      { text: 'Tipo', value: 'tipo', width: '130px' },
      { text: 'Descripción', sortable: false },
      { text: 'Fecha', value: 'fechaCreacion' },
      { text: 'Estatus', value: 'estatus', width: '110px' },
      { text: 'Acciones', sortable: false, width: '90px' },
    ],
    pagination: {
      sortBy: 'fechaCreacion',
      descending: true,
      rowsPerPage: 15,
    },
  }),
  filters: {
    capitalize(v) {
      if (!v) return '';
      return v.charAt(0).toUpperCase() + v.slice(1);
    }
  },
  computed: {
    reclamosFiltrados() {
      let list = this.reclamos;
      if (this.filtroEstatus) list = list.filter(r => r.estatus === this.filtroEstatus);
      if (this.filtroTipo) list = list.filter(r => r.tipo === this.filtroTipo);
      return list;
    }
  },
  created() {
    this.cargar();
  },
  methods: {
    async cargar() {
      try {
        this.loading = true;
        const res = await Api.get('reclamos');
        this.reclamos = res.data;
      } catch (e) {
        console.error(e);
        this.$swal('Error', 'No se pudieron cargar los reclamos', 'error');
      } finally {
        this.loading = false;
      }
    },
    verDetalle(item) {
      this.form = { ...item };
      this.respuestaInput = '';
      this.dialog = true;
    },
    async cambiarEstatus(nuevoEstatus) {
      try {
        this.loading = true;
        await Api.put(`reclamos/${this.form._id}/estatus`, {
          estatus: nuevoEstatus,
          respuesta: this.respuestaInput,
        });
        this.$swal('¡Listo!', `Reclamo marcado como "${nuevoEstatus}"`, 'success');
        this.close();
        this.cargar();
      } catch (e) {
        console.error(e);
        this.$swal('Error', 'No se pudo actualizar el estatus', 'error');
      } finally {
        this.loading = false;
      }
    },
    async eliminar(id) {
      const confirm = await this.$swal({
        title: '¿Eliminar reclamo?',
        text: 'Esta acción no se puede deshacer.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.value) return;
      try {
        this.loading = true;
        await Api.delete(`reclamos/${id}`);
        this.cargar();
      } catch (e) {
        this.$swal('Error', 'No se pudo eliminar', 'error');
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
      this.respuestaInput = '';
      this.form = {
        _id: null, vendedorNombre: '', vendedorCodigo: '', clienteNombre: '',
        tipo: '', descripcion: '', respuesta: '', estatus: 'pendiente', fechaCreacion: null,
      };
    },
    tipoLabel(tipo) {
      const map = { reclamo: 'Reclamo', mejora: 'Oportunidad de Mejora', sugerencia: 'Sugerencia' };
      return map[tipo] || tipo || '—';
    },
    colorTipo(tipo) {
      const map = { reclamo: 'red darken-1', mejora: 'blue darken-1', sugerencia: 'teal' };
      return map[tipo] || 'grey';
    },
    colorEstatus(estatus) {
      const map = { pendiente: 'orange', atendido: 'green', rechazado: 'red' };
      return map[estatus] || 'grey';
    },
    formatDate(val) {
      if (!val) return '—';
      return moment(val).format('DD/MM/YYYY HH:mm');
    },
    esVideo(url) {
      const ext = url.split('?')[0].split('.').pop().toLowerCase();
      return ['mp4', 'mov', 'avi', 'webm', '3gp'].includes(ext);
    },
  }
}
</script>
